import { all } from 'redux-saga/effects';

import monitorsSaga from './monitors';
import partsSaga from './parts';
import stringsSaga from './strings';

// notice how we now only export the rootSaga
// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([
    monitorsSaga(),
    partsSaga(),
    stringsSaga()
  ]);
}
